import styled from 'styled-components';

export const FooterContainer = styled.footer`
  max-width: 600px;
  margin: 40px auto 0;
`;

export const FooterText = styled.p`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 2;
  text-align: center;
  opacity: .8;
  margin: 0;

  a {
    color: black;
    font-weight: 700;
  }
`;

export const CarbonContainer = styled.div`
  margin-top: 16px;
`;
